import { useContext } from "react";
import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";
// import AbrirVentana from "../../reductores/acciones/widgets/AbrirVentana";
import VentanaCliente from "../../../isp.iu.clientes/reductores/ventanas/VentanaCliente";
import VentanaQueryClientes from "../../../isp.iu.clientes/reductores/ventanas/VentanaQueryClientes";

export default function MenuItemsClientes(dispatch) {
    const {
        // dispatchPrincipal,
        abrirVentana,
    } = useContext(GlobalContext);
    return [
        {
            label: "Nuevo Cliente a Facturar",
            icon: "pi pi-fw pi-plus",
            command: () => {
                const nuevaVentana = VentanaCliente.nuevaVentanaEnModoCrear();
                // const nuevaVentana = new VentanaCliente();
                abrirVentana(nuevaVentana);

                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaNuevoClienteAFacturar())
            },
        },
        {
            label: "Listar Clientes a Facturar",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryClientes();
                abrirVentana(nuevaVentana);

                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaQueryClientesAFacturar())
            },
        },
    ];
}
